






















































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as _ from "lodash";
import axios, { resHandle } from "@/plugins/axios";
import wordcloud from "vue-wordcloud";
@Component({
  components: {
    wordcloud,
  },
})
export default class ExpertYongyaoResult extends Vue {
  @Prop()
  private cState: any;
  @Prop()
  private message: any;
  @Prop()
  private result: any;
  @Prop()
  private cFenxi: any;
  private ifShowFloatTab: boolean = false;
  private numberCount: any[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  private pinciLoaded: boolean = false;
  private pinciOption: any = {
    legend: {
      right: "28%",
      top: 50,
      orient: "vertical",
      data: [],
      itemGap: 30,
      icon: "circle",
    },
    color: ["#74A0FA", "#75DDB5", "#7784A2", "#F8C53C", "#EC7E68"],
    series: [
      {
        type: "pie",
        radius: ["0%", "80%"],
        center: ["30%", "50%"],
      },
    ],
  };
  private guanlianguizeOption: any = {
    color: ["#FF8E19"],
    series: [
      {
        type: "graph",
        layout: "force",
        force: {
          repulsion: 1000,
        },
        roam: true,
        label: {
          show: true,
        },
      },
    ],
  };
  private guanlianguizeLoaded: boolean = false;
  private tupuOption: any = {
    series: [
      {
        type: "graph",
        layout: "force",
        force: {
          repulsion: 1000,
        },
        label: {
          show: true,
        },
      },
    ],
  };
  private teyixingLoaded: boolean = false;
  private teyixingOption: any = {
    color: ["#547CFE", "#87A3FE", "#C3D1FF"],
    series: [
      {
        radius: ["15%", "80%"],
        type: "sunburst",
        sort: null,
        highlightPolicy: "ancestor",
        label: {
          color: "#fff",
        },
        levels: [
          {},
          {
            itemStyle: {
              color: "#547CFE",
            },
            label: {
              rotate: "radial",
            },
          },
          {
            itemStyle: {
              color: "#87A3FE",
            },
            label: {
              rotate: "tangential",
            },
          },
          {
            itemStyle: {
              color: "#C3D1FF",
            },
            label: {
              rotate: 0,
            },
          },
        ],
      },
    ],
  };
  private guilvLoaded: boolean = false;
  private guilvOption: any = {
    series: [
      {
        type: "graph",
        layout: "circular",
        roam: "true",
        label: {
          show: true,
        },
      },
    ],
  };
  @Watch("result", { immediate: true, deep: true })
  private resultChange() {
    if (this.cFenxi === "用药配伍") {
      this.createPinci();
      this.createGuanlianguize();
    } else if (this.cFenxi === "用药特异性分析") {
      this.createTeyixing();
    } else if (this.cFenxi === "随症用药规律") {
      this.createGuilv();
    }
  }
  /**
   * @description 切换分析方法
   */
  private typeChange(type) {
    this.$emit("typeChange", type);
  }
  /**
   * @description 监听根部滚动
   */
  private handleScroll() {
    const top = (this.$refs.root as any).scrollTop;
    if (top && top > 200) {
      this.ifShowFloatTab = true;
    } else {
      this.ifShowFloatTab = false;
    }
  }
  /**
   * @description 条件改变后重新请求，不重置条件
   */
  private conditionChange() {
    this.$emit("reDraw");
  }
  /**
   * @description 中医证型变化
   */
  private zhongyizhengxingChange(value) {
    this.$emit("zyzxChange", value);
  }
  /**
   * @description 刷新用药频次
   */
  private refreshPinci() {
    this.createPinci();
  }
  /**
   * @description 用药频次统计明细数据下载
   */
  private downloadPinci(name) {
    const load = this.$loading({
      text: "下载中...请稍后",
    });
    const params: any = _.cloneDeep(this.message);
    params.is_download = true;
    params.download_name = name;
    axios
      .post("api/wajue/zjyyjy/yypw", params)
      .then(({ data }) => {
        resHandle(this, data).then(() => {
          console.log(data);
          window.open(
            window.API_ROOT +
              "api/wajue/download?filename=" +
              data.data.file_name
          );
        });
      })
      .finally(() => {
        load.close();
      });
  }
  /**
   * @description 生成用药频次饼图
   */
  private createPinci() {
    this.pinciOption.legend.data = this.result["用药频次"].name;
    this.pinciOption.series[0].data = this.result["用药频次"].data;
    this.pinciLoaded = true;
  }
  /**
   * @description 生成药物组合的关联规则分析关系图
   */
  private createGuanlianguize() {
    this.guanlianguizeOption.series[0].data = this.result[
      "药物组合的关联规则分析"
    ]["nodes"];
    this.guanlianguizeOption.series[0].categories = this.result[
      "药物组合的关联规则分析"
    ]["categories"];
    this.guanlianguizeOption.series[0].links = this.result[
      "药物组合的关联规则分析"
    ]["links"];
    this.guanlianguizeOption.series[0].symbolSize = (value: any) => {
      return value;
    };
    this.guanlianguizeLoaded = true;
  }
  /**
   * @description 特异性分析
   */
  private analyseTeyixing() {
    this.teyixingLoaded = false;
    const load = this.$loading({
      text: "分析中...请稍后",
    });
    const params: any = _.cloneDeep(this.message);
    axios
      .post("api/wajue/zjyyjy/yyty", params)
      .then(({ data }) => {
        resHandle(this, data).then(() => {
          this.result = data.data;
          this.cFenxi = "用药特异性分析";
          this.createTeyixing();
        });
      })
      .finally(() => {
        load.close();
      });
  }
  /**
   * @description 特异性导出数据
   */
  private downloadTeyixing(name) {
    const load = this.$loading({
      text: "下载中...请稍后",
    });
    const params: any = _.cloneDeep(this.message);
    params.is_download = true;
    params.download_name = name;
    axios
      .post("api/wajue/zjyyjy/yyty", params)
      .then(({ data }) => {
        resHandle(this, data).then(() => {
          console.log(data);
          window.open(
            window.API_ROOT +
              "api/wajue/download?filename=" +
              data.data.file_name
          );
        });
      })
      .finally(() => {
        load.close();
      });
  }
  /**
   * @description 生成特异性饼图
   */
  private createTeyixing() {
    this.teyixingOption.series[0].data = this.result["用药特异性分析"];
    this.teyixingLoaded = true;
  }
  /**
   * @description 随症用药规律
   */
  private analyseGuilv() {
    const load = this.$loading({
      text: "分析中...请稍后",
    });
    const params: any = _.cloneDeep(this.message);
    axios
      .post("api/wajue/zjyyjy/szjj", params)
      .then(({ data }) => {
        resHandle(this, data).then(() => {
          this.guilvLoaded = false;
          this.cFenxi = "随症用药规律";
          this.$forceUpdate();
          this.$nextTick().then(() => {
            this.$emit("resultChange", data.data);
          });
        });
      })
      .finally(() => {
        load.close();
      });
  }
  /**
   * @description 生成随症用药规律关系图
   */
  private createGuilv() {
    this.guilvOption.series[0].data = this.result["随症加减规律"]["nodes"];
    this.guilvOption.series[0].categories = this.result["随症加减规律"][
      "categories"
    ];
    this.guilvOption.series[0].links = this.result["随症加减规律"]["links"];
    this.guilvOption.series[0].symbolSize = (value: any) => {
      return value;
    };
    this.guilvLoaded = true;
  }
  /**
   * @description 随症用药规律导出数据
   */
  private downloadGuilv() {
    const load = this.$loading({
      text: "下载中...请稍后",
    });
    const params: any = _.cloneDeep(this.message);
    params.is_download = true;
    axios
      .post("api/wajue/zjyyjy/szjj", params)
      .then(({ data }) => {
        resHandle(this, data).then(() => {
          console.log(data);
          window.open(
            window.API_ROOT +
              "api/wajue/download?filename=" +
              data.data.file_name
          );
        });
      })
      .finally(() => {
        load.close();
      });
  }
}
